<template>
  <VModalWidget
    :dismiss="dismiss"
    :submit="doSubmit"
    :submitting="working"
    :submitTitle="$t('labels.save')"
    :loading="loading"
  >
    <template v-slot:title>{{ $t('labels.agency') }}</template>

    <template v-slot:content>
      <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
      <v-form>
        <v-text-field
          v-model.trim="form.display"
          :error-messages="displayErrors"
          v-bind:label="$t('labels.displayName')"
          required
          @input="$v.form.display.$touch()"
          @blur="$v.form.display.$touch()"
        ></v-text-field>
        <v-text-field
          v-model.trim="form.agency_code"
          :error-messages="codeErrors"
          v-bind:label="$t('labels.agencyCode')"
          required
          :disabled="!isNew"
          @input="$v.form.agency_code.$touch()"
          @blur="$v.form.agency_code.$touch()"
        ></v-text-field>
      </v-form>
    </template>
  </VModalWidget>
</template>

<script>
import pick from 'lodash/pick'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { BaseForm, FormErrors, VModalWidget } from '@argon/app/components'
import { Modal } from '@argon/app/mixins'
import { NAMESPACE } from '../store'

export default {
  name: 'ModalAgency',
  extends: BaseForm,
  mixins: [Modal],
  components: {
    FormErrors,
    VModalWidget
  },
  props: {
    agencyId: { type: [Number, String], required: true },
    firmId: { type: [Number, String], required: true }
  },
  validations: {
    form: {
      display: { required },
      agency_code: { required }
    }
  },
  data() {
    return {
      form: {
        display: '',
        agency_code: ''
      },
      loading: false,
      working: false
    }
  },
  computed: {
    isNew() {
      return this.agencyId === 'new'
    },
    displayErrors() {
      const errors = []
      if (!this.$v.form.display.$dirty) return errors
      !this.$v.form.display.required && errors.push(this.$t('required'))
      this.getServerErrors('display', errors)
      return errors
    },
    codeErrors() {
      const errors = []
      if (!this.$v.form.agency_code.$dirty) return errors
      !this.$v.form.agency_code.required && errors.push(this.$t('required'))
      this.getServerErrors('agency_code', errors)
      return errors
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['createAgency', 'getAgency', 'patchAgency']),
    doSubmit() {
      this.resetServerErrors()
      if (this.$v.form.$invalid) {
        return this.$v.form.$touch()
      }
      let callback = this.isNew ? this.createAgency : this.patchAgency
      let data = this.isNew
        ? { firmId: this.firmId, data: this.form }
        : { agencyId: this.agencyId, firmId: this.firmId, data: pick(this.form, ['display']) }
      return callback(data)
        .then((resp) => {
          this.dismiss()
        })
        .catch(this.setServerErrors)
        .finally(() => {
          this.working = false
        })
    }
  },

  created() {
    if (this.isNew) {
      return
    }
    this.getAgency({ agencyId: this.agencyId, firmId: this.firmId })
      .then((agency) => {
        this.form = pick(agency, ['display', 'agency_code'])
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
